<div [class.small]="small" [class.x-small]="x_small">
  <mat-icon [class.mb-2]="!x_small" [class.mb-1]="x_small">{{ iconName }}</mat-icon>
  {{ text }}
</div>
